<template>
  <div>
    <!-- <div v-if="isLoading" class="loading-overlay">
      <div class="loader"></div>
    </div> -->
    <!-- <div @click="updateChartPeriod(14)">切换周期</div> -->
    <div
      ref="chartContainer"
      :id="chartContainerId"
      :style="{ width: `100%` }"
      class="tv_box"
    ></div>
  </div>
</template>

<script>
import { Envelope, Candle } from "@/generated/proto";
import MD5 from "crypto-js/md5";
import { getDeviceId } from "@/utils/deviceId";
import { getOperatingSystem } from "@/utils/platform";

const SPOT_KLINE_URL =
  "https://api.shlwsj.asia/bjw-front/pc/market/currency/v1/open/querySpotKline";

export default {
  data() {
    return {
      chartContainer: null,
      coinName: "BTC",
      coinId: 1,
      periodTypeStr: 2,
      chartContainerId: "chart",
      filterIndex: false,
      klineData: [],
      actIndex: 1,
      isLoading: true,
      indexList: [
        {
          type: "美国线",
          id: 0,
        },
        {
          type: "K线图",
          id: 1,
        },
        {
          type: "空心K线图",
          id: 9,
        },
        {
          type: "平均K线图",
          id: 8,
        },
        {
          type: "线型图",
          id: 2,
        },
        {
          type: "面积图",
          id: 3,
        },
      ],
      tvWidget: null,
      loadingGet: true,
      page: 1,
      spotKlineExhausted: false,
      typeShow: false,
      Datafeed: null,
      height: 50,
      mode: 0, //主题：0浅色 1深色
      language: "zh",
      colorConfig: 0, //0 绿涨红跌  1 红涨绿跌
      isMin: false,
      pageType: 0, //0 代币 1 板块 2 合约
      ws: null,
      dataType: 0,
      scale: 2,
      isWsSubscribed: false,
      currentSubscribedCycle: null,
      heartbeatTimer: null, // ping定时器
      heartbeatCheckTimer: null, // 检查pong超时的定时器
      lastPongTime: null, // 最后收到pong的时间
    };
  },
  methods: {
    /** 现货 K 线 period 参数（分钟，字符串），与接口文档一致 */
    getSpotKlinePeriodParam(periodType) {
      const map = {
        13: "1",
        14: "5",
        1: "15",
        2: "60",
        10: "120",
        11: "240",
        3: "1440",
        4: "10080",
        5: "43200",
        12: "129600",
      };
      return map[periodType] || "60";
    },
    /** 解析 querySpotKline 返回的二维数组：ts, open, close, high, low, volume, amount */
    parseSpotKlineRows(payload) {
      if (payload == null) return [];
      const rows = Array.isArray(payload) ? payload : payload.list;
      if (!Array.isArray(rows) || rows.length === 0) return [];
      if (!Array.isArray(rows[0])) return [];
      return rows
        .map((row) => ({
          time: Number(row[0]),
          open: Number(row[1]),
          close: Number(row[2]),
          high: Number(row[3]),
          low: Number(row[4]),
          volume: Number(row[6]),
        }))
        .filter((b) => !Number.isNaN(b.time))
        .sort((a, b) => a.time - b.time);
    },
    // 获取周期映射
    getIntervalMapping() {
      return {
        1: "15m",
        2: "1H",
        3: "1Dutc",
        4: "1Wutc",
        5: "1Mutc",
        10: "2H",
        11: "4H",
        12: "3Mutc",
        13: "1m",
        14: "5m",
      };
    },

    // 发送WebSocket订阅消息
    sendSubscribeMessage(cycle) {
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
        console.warn("WebSocket未连接，无法发送订阅消息");
        return false;
      }

      let data = {
        op: "subscribe",
        name: this.pageType == 0 ? "candle" : this.pageType == 1 ? "plate_history" : 0,
        cycle: cycle,
        type: this.dataType,
      };

      if (this.pageType == 0) {
        data.currencyId = this.coinId;
      } else if (this.pageType == 1) {
        data.plateIds = [this.coinId];
      }

      this.ws.send(JSON.stringify(data));
      console.log("发送订阅消息:", data);
      return true;
    },

    // 发送WebSocket取消订阅消息
    sendUnsubscribeMessage(cycle) {
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
        console.warn("WebSocket未连接，无法发送取消订阅消息");
        return false;
      }

      let data = {
        op: "unsubscribe",
        name: this.pageType == 0 ? "candle" : this.pageType == 1 ? "plate_history" : 0,
        cycle: cycle,
        type: this.dataType,
      };

      if (this.pageType == 0) {
        data.currencyId = this.coinId;
      } else if (this.pageType == 1) {
        data.plateIds = [this.coinId];
      }

      this.ws.send(JSON.stringify(data));
      console.log("发送取消订阅消息:", data);
      return true;
    },

    // 重新订阅WebSocket
    resubscribeWebSocket(newCycle) {
      // 如果当前有订阅，先取消订阅
      if (this.isWsSubscribed && this.currentSubscribedCycle) {
        this.sendUnsubscribeMessage(this.currentSubscribedCycle);
        this.isWsSubscribed = false;
      }

      // 订阅新的周期
      if (this.sendSubscribeMessage(newCycle)) {
        this.isWsSubscribed = true;
        this.currentSubscribedCycle = newCycle;
      }
    },
    wsSocket() {
      // 生成鉴权参数（与HTTP请求保持一致）
      const timestamp = Date.now();
      const apiSecret = "jFhDhQZCdP";
      const timestampPrefix = timestamp.toString().substring(0, 6);
      const stringToSign = `${timestamp}${apiSecret}${timestampPrefix}`;
      const sign = MD5(stringToSign);

      const token = localStorage.getItem("token");
      const deviceId = getDeviceId();
      // 将鉴权参数添加到WebSocket URL中
      const params = new URLSearchParams({
        sign: sign,
        timestamp: timestamp,
        source: getOperatingSystem(),
        Authorization: token || "",
        deviceId: deviceId,
      });

      const wsUrl = `wss://api.shlwsj.asia/xhj-gather-app/open/websocketV2?${params.toString()}`;

      this.ws = new WebSocket(wsUrl);
      this.ws.binaryType = "arraybuffer";
      const intervalMapping = this.getIntervalMapping();
      let cycle = intervalMapping[this.periodTypeStr];

      this.ws.onopen = () => {
        console.log("WebSocket连接已建立");
        // 记录连接时间
        this.lastPongTime = Date.now();

        // 启动心跳机制
        this.startHeartbeat();

        // 发送初始订阅消息
        if (this.sendSubscribeMessage(cycle)) {
          this.isWsSubscribed = true;
          this.currentSubscribedCycle = cycle;
        }
      };

      this.ws.onmessage = (event) => {
        // 处理PONG响应（支持字符串格式）
        if (typeof event.data === "string" && event.data === "PONG") {
          this.lastPongTime = Date.now();
          console.log("收到PONG响应");
          return;
        }

        // 处理二进制格式的PONG
        if (event.data instanceof ArrayBuffer) {
          try {
            const text = new TextDecoder().decode(event.data);
            if (text === "PONG" || text === "pong") {
              this.lastPongTime = Date.now();
              console.log("收到PONG响应");
              return;
            }
          } catch (e) {
            // 如果解码失败，继续处理为正常数据
          }
        }

        const envelope = Envelope.decode(new Uint8Array(event.data)); // 通过 decode 进行解码
        // 获取 business 字段并解码为 Candle 消息
        const kline = Candle.decode(envelope.business); // 解码 Envelope 的 business 字段为 Candle 消息
        const data = kline;
        if (data) {
          this.lastPrice = data.closePrice; // 最新价格
          console.log(data, "data");
          if (this.realtimeUpdateCallback) {
            const bar = {
              time: data.timestamp * 1000,
              close: data.closePrice,
              open: data.openPrice,
              high: data.highPrice,
              low: data.lowPrice,
              volume: data.turnover,
            };
            this.realtimeUpdateCallback(bar);
          }
        }
      };

      this.ws.onclose = () => {
        console.log("WebSocket连接已关闭，尝试重新连接...");
        this.isWsSubscribed = false;
        this.currentSubscribedCycle = null;
        // 清理心跳定时器
        this.stopHeartbeat();
        setTimeout(() => this.wsSocket(), 3000);
      };

      this.ws.onerror = (error) => {
        console.error("WebSocket发生错误:", error);
        this.isWsSubscribed = false;
        this.currentSubscribedCycle = null;
      };
    },

    // 启动心跳机制
    startHeartbeat() {
      // 每2秒发送一次ping
      this.heartbeatTimer = setInterval(() => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
          this.ws.send("PING");
          console.log("发送PING");
        }
      }, 2000);

      // 每15秒检查一次是否收到pong
      this.heartbeatCheckTimer = setInterval(() => {
        if (this.lastPongTime && Date.now() - this.lastPongTime > 15000) {
          console.warn("15秒未收到PONG，关闭连接");
          if (this.ws) {
            this.ws.close();
          }
        }
      }, 15000);
    },

    // 停止心跳机制
    stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
      if (this.heartbeatCheckTimer) {
        clearInterval(this.heartbeatCheckTimer);
        this.heartbeatCheckTimer = null;
      }
      this.lastPongTime = null;
    },

    loadChart() {
      const script = document.createElement("script");
      script.src = "/charting_library/charting_library.js"; // 引入 Charting Library
      script.onload = () => {
        // 立即初始化TradingView，不等待数据
        this.initKline();
      };
      document.body.appendChild(script);
    },
    openType() {
      this.filterIndex = true;
    },
    closeIndex() {
      this.filterIndex = false;
    },
    getInterval(periodType) {
      const intervalMapping = {
        1: "15",
        2: "60",
        3: "1D",
        4: "1W",
        5: "1M",
        10: "120",
        11: "240",
        12: "3M",
        13: "1",
        14: "5",
      };
      return intervalMapping[periodType];
    },
    getDatafeed() {
      const configurationData = {
        supported_resolutions: ["60", "15", "1D", "1W", "1M", "120", "240", "3M", "1", "5"],
        exchanges: [{ value: "528BTC", name: "528BTC", desc: "528BTC" }],
        symbols_types: [{ name: "行情分析", value: "行情分析" }],
      };

      return {
        noData: false,
        onReady: (callback) => {
          console.log("[onReady]: Method call");
          setTimeout(() => callback(configurationData));
        },
        searchSymbols: (userInput, exchange, symbolType, onResultReadyCallback) => {
          console.log("[searchSymbols]: Method call");
          onResultReadyCallback([]); // 不允许用户搜索交易对
        },
        resolveSymbol: async (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) => {
          console.log("[resolveSymbol]: Method call", symbolName);
          // 默认初始价格比例设置
          let pricescale = Math.pow(10, this.scale);
          const symbolInfo = {
            ticker: "528BTC:BTC/USDT",
            name: "BTC/USDT",
            description: "BTC/USDT",
            type: "行情分析",
            exchange: "528BTC",
            session: "24x7",
            timezone: "Asia/Shanghai",
            minmov: 1,
            pricescale: pricescale,
            has_intraday: true,
            visible_plots_set: "ohlc",
            supported_resolutions: configurationData.supported_resolutions,
            volume_precision: 2,
            data_status: "streaming",
          };

          // 更新符号信息
          symbolInfo.ticker = `528BTC:${this.coinName}${this.pageType == 0 ? "/USDT" : ""}`;
          symbolInfo.name = `${this.coinName}${this.pageType == 0 ? "/USDT" : ""}`;
          symbolInfo.description = `${this.coinName}${this.pageType == 0 ? "/USDT" : ""}`;

          setTimeout(() => {
            onSymbolResolvedCallback(symbolInfo);
          });
        },
        getBars: async (
          symbolInfo,
          resolution,
          periodParams,
          onHistoryCallback,
          onErrorCallback
        ) => {
          const { from, to, firstDataRequest, countBack } = periodParams;

          if (firstDataRequest) {
            // 首次请求时加载数据
            try {
              let klineData = null;
              if (this.pageType == 0) {
                klineData = await this.getKlList(true);
              } else if (this.pageType == 1) {
                klineData = await this.getsdList(true);
              } else {
              }

              if (klineData && klineData.length > 0) {
                onHistoryCallback(klineData);
              } else {
                onHistoryCallback([], { noData: true });
              }
            } catch (error) {
              console.error("[getBars]: Error fetching initial data", error);
              onErrorCallback(error);
            }
          } else {
            // 加载更多历史数据
            if (!this.loadingGet || this.klineData.length < 300) {
              onHistoryCallback([], { noData: true });
            } else if (this.pageType == 0 && this.spotKlineExhausted) {
              onHistoryCallback([], { noData: true });
            } else {
              this.loadingGet = false;
              try {
                if (this.pageType == 0) {
                  const endTime = this.klineData[0].time;
                  const res = await this.$axios.get(SPOT_KLINE_URL, {
                    params: {
                      currencyId: this.coinId,
                      period: this.getSpotKlinePeriodParam(this.periodTypeStr),
                      limit: 300,
                      endTime,
                    },
                  });
                  this.loadingGet = true;
                  if (res.data.code == 200) {
                    const moreKlineData = this.parseSpotKlineRows(res.data.data);
                    if (moreKlineData.length > 0) {
                      const existing = new Set(this.klineData.map((b) => b.time));
                      const olderOnly = moreKlineData.filter((b) => !existing.has(b.time));
                      if (olderOnly.length === 0) {
                        this.spotKlineExhausted = true;
                        onHistoryCallback([], { noData: true });
                      } else {
                        this.klineData = [...olderOnly, ...this.klineData].sort(
                          (a, b) => a.time - b.time
                        );
                        onHistoryCallback(olderOnly);
                      }
                    } else {
                      this.spotKlineExhausted = true;
                      onHistoryCallback([], { noData: true });
                    }
                  } else {
                    onHistoryCallback([], { noData: true });
                  }
                } else if (this.pageType == 1) {
                  this.page++;
                  const res = await this.$axios.get(
                    "https://api.shlwsj.asia" + "/xhj-gather-app/open/coin/plateHistory/page",
                    {
                      params: {
                        plateId: this.coinId,
                        limit: 300,
                        page: this.page,
                        periodType: this.periodTypeStr,
                        sortByDate: true,
                        sortByDateRule: false,
                        type: this.dataType,
                      },
                    }
                  );
                  this.loadingGet = true;
                  if (res.data.code == 200) {
                    const list = res.data.data.list;
                    if (list && list.length > 0) {
                      const moreKlineData = list
                        .sort((cur, next) => cur.date - next.date)
                        .map((item) => {
                          return {
                            time: item.date * 1000,
                            low: item.priceMin,
                            high: item.priceMax,
                            open: item.priceOpen,
                            close: item.priceClose,
                            volume: item.turnover,
                          };
                        });
                      onHistoryCallback(moreKlineData);
                    } else {
                      onHistoryCallback([], { noData: true });
                    }
                  } else {
                    onHistoryCallback([], { noData: true });
                  }
                } else {
                  this.loadingGet = true;
                  onHistoryCallback([], { noData: true });
                }
              } catch (error) {
                this.loadingGet = true;
                console.error("[getBars]: Error fetching more data", error);
                onErrorCallback(error);
              }
            }
          }
        },
        subscribeBars: (
          symbolInfo,
          resolution,
          onRealtimeCallback,
          subscriberUID,
          onResetCacheNeededCallback
        ) => {
          console.log(`[subscribeBars]: 订阅${symbolInfo.name}的实时数据, 分辨率: ${resolution}`);

          // 启动WebSocket连接，如果尚未启动
          if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
            if (this.dataType != 1) {
              this.wsSocket();
            }
          }

          // 保存回调函数，供WebSocket收到数据时调用
          this.realtimeUpdateCallback = onRealtimeCallback;

          // 保存订阅ID，用于之后取消订阅
          this.subscriberUID = subscriberUID;
        },

        unsubscribeBars: (subscriberUID) => {
          console.log(`[unsubscribeBars]: 取消订阅ID: ${subscriberUID}`);

          // 如果取消的是当前订阅，则清除回调
          if (subscriberUID === this.subscriberUID) {
            this.realtimeUpdateCallback = null;
            this.subscriberUID = null;

            // 取消WebSocket订阅
            if (this.isWsSubscribed && this.currentSubscribedCycle) {
              this.sendUnsubscribeMessage(this.currentSubscribedCycle);
              this.isWsSubscribed = false;
              this.currentSubscribedCycle = null;
            }
          }
        },
      };
    },
    generateTradingViewAndMount() {
      this.Datafeed = this.getDatafeed();
      let upColor = this.colorConfig == 0 ? "#09C274" : "#F23F58";
      let downColor = this.colorConfig == 0 ? "#F23F58" : "#09C274";
      const tradingViewConfig = {
        symbol: `528BTC:${this.coinName}${this.pageType == 0 ? "/USDT" : ""}`,
        interval: this.getInterval(this.periodTypeStr),
        timezone: "Asia/Shanghai",
        container: this.chartContainerId,
        datafeed: this.Datafeed,
        locale: this.language,
        width: "100%",
        height: "100%",
        library_path: "/charting_library/",
        theme: this.mode == 0 ? "Light" : "Dark",
        enabled_features: ["hide_left_toolbar_by_default"],
        disabled_features: [
          "header_widget",
          "timeframes_toolbar",
          "pre_post_market_sessions",
          "display_market_status",
        ],
        toolbar_bg: this.mode == 0 ? "#ffffff" : "#000000",
        custom_css_url: "dark.css",
        // 添加自定义加载配置
        loading_screen: {
          foregroundColor: "#FFD600",
        },
        studies_overrides: {
          // 成交量上涨颜色
          "volume.volume.color.0": downColor,
          // 成交量下跌颜色
          "volume.volume.color.1": upColor,
          // 成交量透明度
          "volume.volume.transparency": 0,
        },
        // 暗黑模式下设置图表背景色
        overrides:
          this.mode == 1
            ? {
                "paneProperties.background": "#121212",
                "paneProperties.backgroundType": "solid",
                "paneProperties.backgroundGradientStartColor": "#121212",
                "paneProperties.backgroundGradientEndColor": "#121212",
              }
            : {},
      };

      const tvWidget = new TradingView.widget(tradingViewConfig);

      tvWidget.onChartReady(() => {
        const chart = tvWidget.chart();

        // 暗黑模式下设置图表背景色为 #121212
        if (this.mode == 1) {
          // 使用 applyOverrides 方法设置背景色
          chart.applyOverrides({
            "paneProperties.background": "#121212",
            "paneProperties.backgroundType": "solid",
            "paneProperties.backgroundGradientStartColor": "#121212",
            "paneProperties.backgroundGradientEndColor": "#121212",
          });

          // 同时设置 CSS 变量作为备用
          tvWidget.setCSSCustomProperty("--tv-color-pane-background", "#121212");
          tvWidget.setCSSCustomProperty("--tv-color-pane-background-secondary", "#121212");
        }

        chart.createStudy("Volume", false, false);
        if (this.dataType == 1) {
          chart.setChartType(3);
        } else {
          chart.setChartType(this.actIndex);
        }
        chart.getSeries().setChartStyleProperties(1, {
          upColor: upColor,
          downColor: downColor,
          borderUpColor: upColor,
          borderDownColor: downColor,
          wickDownColor: downColor,
          wickUpColor: upColor,
        });
        chart.getSeries().setChartStyleProperties(3, {
          // 面积图的颜色属性
          linecolor: "rgba(243, 191, 8, 1)", // 线条颜色
          color1: "rgba(243, 191, 8, 0.2)",
          color2: "rgba(243, 191, 8, 0)",
          linewidth: 1,
        });
      });

      return tvWidget;
    },
    openIndicators() {
      if (this.tvWidget) {
        this.tvWidget.chart().executeActionById("insertIndicator");
      }
    },
    openSetChart() {
      if (this.tvWidget) {
        this.tvWidget.chart().executeActionById("chartProperties");
      }
    },
    changeBar(val) {
      this.filterIndex = false;
      if (this.tvWidget) {
        this.tvWidget.onChartReady(() => {
          const chart = this.tvWidget.chart();
          chart.setChartType(val);
          this.typeShow = false;
        });
      }
    },
    showTypeBar() {
      this.typeShow = !this.typeShow;
    },
    chartReset() {
      if (this.tvWidget) {
        this.tvWidget.chart().executeActionById("chartReset");
        this.tvWidget.onChartReady(() => {
          const chart = this.tvWidget.chart();

          // 暗黑模式下设置图表背景色为 #121212
          if (this.mode == 1) {
            // 使用 applyOverrides 方法设置背景色
            chart.applyOverrides({
              "paneProperties.background": "#121212",
              "paneProperties.backgroundType": "solid",
              "paneProperties.backgroundGradientStartColor": "#121212",
              "paneProperties.backgroundGradientEndColor": "#121212",
            });

            // 同时设置 CSS 变量作为备用
            this.tvWidget.setCSSCustomProperty("--tv-color-pane-background", "#121212");
            this.tvWidget.setCSSCustomProperty("--tv-color-pane-background-secondary", "#121212");
          }

          this.tvWidget.setCSSCustomProperty(
            "--tv-color-toolbar-button-background-hover",
            "rgb(0, 0, 0)"
          );
          chart.setChartType(1);
          chart.removeAllStudies();
          chart.createStudy("Volume", false, false);
          chart.createStudy(
            "Moving Average",
            false,
            false,
            { length: 5 },
            {
              "plot.color": "#F5C48C",
              precision: 2,
              showLabelsOnPriceScale: false,
            }
          );
          chart.createStudy(
            "Moving Average",
            false,
            false,
            { length: 10 },
            {
              "plot.color": "#9773BF",
              precision: 2,
              showLabelsOnPriceScale: false,
            }
          );
          chart.createStudy(
            "Moving Average",
            false,
            false,
            { length: 30 },
            {
              "plot.color": "#5B8DF7",
              precision: 2,
              showLabelsOnPriceScale: false,
            }
          );
        });
      }
    },
    initKline() {
      // 创建并挂载TradingView实例
      this.tvWidget = this.generateTradingViewAndMount();

      // 图表准备就绪后再隐藏加载状态
      this.tvWidget.onChartReady(() => {
        this.isLoading = false;
      });
    },
    getKlList(isFirstLoad = false) {
      this.spotKlineExhausted = false;
      return new Promise((resolve, reject) => {
        this.$axios
          .get(SPOT_KLINE_URL, {
            params: {
              currencyId: this.coinId,
              period: this.getSpotKlinePeriodParam(this.periodTypeStr),
              limit: 400,
            },
          })
          .then((res) => {
            if (res.data.code == 200) {
              const processedData = this.parseSpotKlineRows(res.data.data);

              this.klineData = processedData;

              // 设置可见范围（仅在首次加载时）
              if (isFirstLoad && this.tvWidget && processedData.length > 0) {
                const length = processedData.length <= 150 ? processedData.length - 1 : 150;
                this.tvWidget.onChartReady(() => {
                  const chart = this.tvWidget.chart();
                  if (processedData[length] && processedData[0]) {
                    chart.setVisibleRange({
                      from: processedData[length].time / 1000,
                      to: processedData[0].time / 1000,
                    });
                  }
                });
              }

              resolve(processedData);
            } else {
              resolve([]);
            }
          })
          .catch((error) => {
            console.error("Failed to get K-line data:", error);
            reject(error);
          });
      });
    },
    getsdList(isFirstLoad = false) {
      return new Promise((resolve, reject) => {
        this.$axios
          .get("https://api.shlwsj.asia" + "/xhj-gather-app/open/coin/plateHistory/page", {
            params: {
              plateId: this.coinId,
              limit: 300,
              page: 1,
              periodType: this.periodTypeStr,
              sortByDate: true,
              sortByDateRule: false,
              type: this.dataType,
            },
          })
          .then((res) => {
            if (res.data.code == 200) {
              let list = res.data.data.list;
              const processedData = list
                .sort((cur, next) => cur.date - next.date)
                .map((item) => ({
                  time: item.date * 1000,
                  low: item.priceMin,
                  high: item.priceMax,
                  open: item.priceOpen,
                  close: item.priceClose,
                  volume: item.amount,
                }));

              this.klineData = processedData;

              // 设置可见范围（仅在首次加载时）
              if (isFirstLoad && this.tvWidget && processedData.length > 0) {
                const length = processedData.length <= 150 ? processedData.length - 1 : 150;
                this.tvWidget.onChartReady(() => {
                  const chart = this.tvWidget.chart();
                  if (processedData[length] && processedData[0]) {
                    chart.setVisibleRange({
                      from: processedData[length].time / 1000,
                      to: processedData[0].time / 1000,
                    });
                  }
                });
              }

              resolve(processedData);
            } else {
              resolve([]);
            }
          })
          .catch((error) => {
            console.error("Failed to get K-line data:", error);
            reject(error);
          });
      });
    },
    // 更新周期不重新加载TradingView，只更新数据
    updateChartPeriod(periodType) {
      if (periodType === this.periodTypeStr) return;

      const oldPeriodType = this.periodTypeStr;
      this.periodTypeStr = periodType;
      this.page = 1;
      this.spotKlineExhausted = false;

      // 获取新的周期对应的cycle
      const intervalMapping = this.getIntervalMapping();
      const newCycle = intervalMapping[periodType];

      console.log(
        `更新周期: ${oldPeriodType} -> ${periodType}, cycle: ${this.currentSubscribedCycle} -> ${newCycle}`
      );

      // 重新订阅WebSocket（取消旧订阅，订阅新周期）
      if (newCycle && newCycle !== this.currentSubscribedCycle) {
        this.resubscribeWebSocket(newCycle);
      }

      // 更新图表配置而不重新创建实例
      if (this.tvWidget) {
        // 更新间隔
        const interval = this.getInterval(periodType);
        this.tvWidget.chart().setResolution(interval);
      }
    },
  },
  mounted() {
    this.$dsbridge.callmethod("config", "h5", (data) => {
      if (data) {
        let configData = JSON.parse(data);
        //获取涨跌幅配置
        if (configData.colorConfig || configData.colorConfig == 0) {
          this.colorConfig = configData.colorConfig;
        }
        //获取主题配置
        if (configData.mode || configData.mode == 0) {
          this.mode = configData.mode;
        }
        //获取币种id
        if (configData.tokenId || configData.tokenId == 0) {
          this.coinId = configData.tokenId;
        }
        //获取币种名称
        if (configData.tokenName) {
          this.coinName = configData.tokenName;
        }
        //获取周期
        if (configData.chartPeriod || configData.chartPeriod == 0) {
          if (configData.chartPeriod == 0) {
            this.periodTypeStr = 13;
            this.isMin = true;
          } else {
            this.periodTypeStr = configData.chartPeriod;
          }
        }
        //获取 市值 - 价格
        if (configData.chartDataType || configData.chartDataType == 0) {
          this.dataType = configData.chartDataType;
        }
        //获取页面类型
        if (configData.pageType || configData.pageType == 0) {
          this.pageType = configData.pageType;
        }
        // 语言映射
        const localeMapping = {
          cn: "zh",
          en: "en",
          tn: "zh_TW",
        };
        //获取语言
        if (configData.language) {
          this.language = localeMapping[configData.language];
        }

        //获取价格精度
        if (configData.priceScale) {
          this.scale = configData.priceScale;
        }
      }
      this.loadChart();
    });
    //设置图标类型方法
    this.$dsbridge.registermethod("setChartType", (res) => {
      this.actIndex = res;
      if (!this.isMin) {
        this.changeBar(res);
      }
    });
    //打开tradingview设置
    this.$dsbridge.registermethod("showQuota", (res) => {
      this.openSetChart();
    });
    //打开tradingview指标
    this.$dsbridge.registermethod("showAssist", (res) => {
      this.openIndicators();
    });
    //改周期
    this.$dsbridge.registermethod("setTimePeriod", (res) => {
      if (res) {
        this.updateChartPeriod(res);
        if (this.isMin) {
          this.changeBar(this.actIndex);
          this.isMin = false;
        }
      } else {
        this.updateChartPeriod(13);
        this.isMin = true;
        this.changeBar(3);
      }
    });
    //市值价格方法
    this.$dsbridge.registermethod("chartDataType", (res) => {
      this.page = 1;
      this.dataType = res;

      const intervalMapping = this.getIntervalMapping();
      const currentCycle = intervalMapping[this.periodTypeStr];
      if (currentCycle) {
        this.resubscribeWebSocket(currentCycle);
      }

      this.initKline();
    });
    localStorage.removeItem("tradingview.current_theme.name");
  },

  // 组件销毁时清理WebSocket连接
  beforeDestroy() {
    // 停止心跳机制
    this.stopHeartbeat();

    if (this.ws) {
      // 发送取消订阅消息
      if (this.isWsSubscribed && this.currentSubscribedCycle) {
        this.sendUnsubscribeMessage(this.currentSubscribedCycle);
      }
      this.ws.close();
      this.ws = null;
    }
  },
};
</script>

<style lang="scss">
.chart_toolbar {
  margin-bottom: 2rem;
  padding: 0 2rem;
  width: 100%;
  height: 4.67rem;

  .toolbar_Box {
    position: relative;
  }

  .chartstype_box {
    position: absolute;
    top: 4rem;
    padding: 0 0.67rem;
    background: #ffffff;
    box-shadow: 0rem 1.33rem 1.67rem -0.83rem rgba(0, 0, 0, 0.08);
    border-radius: 1rem 1rem 1rem 1rem;
    border: 0.17rem solid #ecedf3;

    .chartstype_item {
      text-align: center;
      width: 10rem;
      height: 6.17rem;
      line-height: 6.17rem;
      font-size: 2rem;
      color: #111111;
    }
  }

  .charts_type {
    margin-right: 2rem;
    width: 2.67rem;
    height: 2.67rem;
  }

  .toolbar_icon {
    margin-left: 2rem;
    width: 2.67rem;
    height: 2.67rem;
  }
}
.tv_box {
  height: 100vh !important;
}
// 弹出层
.popup_head {
  margin: 1.33rem 2.67rem 2rem;

  .popup_title {
    height: 6.33rem;
    font-weight: 600;
    font-size: 2.67rem;
    color: #0d111c;
    line-height: 6.33rem;
  }

  .popup_close {
    width: 3.67rem;
    height: 3.67rem;
  }
}

.popup_content {
  padding: 0 2.67rem;

  .s_title {
    font-size: 2rem;
    color: #7c8597;
    line-height: 2rem;
  }
}

.popup_time {
  margin: 0 2.67rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.67rem;

  .time_item {
    height: 5.33rem;
    background: #f4f7fb;
    border-radius: 1rem 1rem 1rem 1rem;
    border: 0.33rem solid rgba(0, 0, 0, 0);
    font-weight: 400;
    font-size: 2rem;
    color: #0d111c;
    line-height: 5.33rem;
    text-align: center;

    &.active {
      background: #fff8d6;
      color: #e0ab05;
    }
  }
}

//加载
/* 加载器的样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  border: 8px solid #f3f3f3;
  /* 灰色背景 */
  border-top: 8px solid #3498db;
  /* 蓝色转圈部分 */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  /* 旋转动画 */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
